module.exports = __webpack_public_path__ + "img/icon-52.48ad8cfd.svg";